import React, { PropsWithChildren } from 'react';
import { Typography, TypographyProps } from '@mui/material';

export function TooltipText({ children, ...rest }: PropsWithChildren<TypographyProps>) {
  return (
    <Typography variant="body2" {...rest}>
      {children}
    </Typography>
  );
}

export const TooltipContent = React.Fragment;

export function TooltipTextContent(props: { text: string }) {
  return (
    <>
      {props.text
        .split('\n')
        .map((line) => line.trim())
        .filter((line) => line !== '')
        .map((line, index) => (
          <TooltipText key={`${index} ${line}`}>{line}</TooltipText>
        ))}
    </>
  );
}
